<ng-container *transloco="let t">
    <div
        class="container"
        fxLayout="row"
        fxLayoutAlign.xs="center"
        fxLayoutAlign.sm="center"
    >
        <div
            fxLayout="row"
            fxLayout.xs="column"
            fxLayout.sm="column"
            fxFlex.xs="90%"
            fxFlex.sm="90%"
            fxLayoutAlign="space-between start"
            fxLayoutAlign.xs="space-between center"
            fxLayoutAlign.sm="space-between center"
        >
            <h1 class="visually-hidden">
                {{ t("application.tab.disclosure") }}
            </h1>
            <div
                fxFlex="612px"
                fxLayoutAlign="center center"
                class="left-area"
                fxFlex.xs="100"
                fxFlex.sm="100"
            >
                <mat-card appearance="outlined">
                    <img
                        src="assets/img/application-icons/disclosure-icon.svg"
                        alt="disclosure-icon"
                    />
                    <h2 [innerHTML]="t('application.disclosure.header')"></h2>
                    <div id="disclosure-consent-text">
                        <p
                            class="title"
                            *ngIf="client?.disclosureHtml1"
                            [innerHTML]="client?.disclosureHtml1"
                        ></p>
                        <p
                            class="title"
                            *ngIf="client?.disclosureHtml2"
                            [innerHTML]="client?.disclosureHtml2"
                        ></p>
                    </div>
                    <form
                        [formGroup]="disclosureForm"
                        (ngSubmit)="onSubmitted()"
                        fxLayout="column"
                    >
                        <ng-container *ngIf="formSections$ | async as sections">
                            <div
                                *ngFor="let section of sections; let i = index"
                                #sectionWrapper
                            >
                                <ng-container *ngIf="isSectionVisible(section)">
                                    <mat-divider *ngIf="i > 0"></mat-divider>
                                    <div
                                        class="sub-title"
                                        *ngIf="
                                            section.title ||
                                            section.titleKey ||
                                            section.flyoutKey
                                        "
                                    >
                                        <h3
                                            *ngIf="
                                                section.title ||
                                                section.titleKey
                                            "
                                        >
                                            {{
                                                t(
                                                    section.titleKey ??
                                                        section.title ??
                                                        section.key ??
                                                        ""
                                                )
                                            }}
                                        </h3>
                                        <app-section-flyout
                                            [flyoutKey]="section.flyoutKey"
                                            [active]="activeFlyoutIndex === i"
                                            [flipUp]="
                                                flyoutFlipUp &&
                                                activeFlyoutIndex === i
                                            "
                                        />
                                    </div>

                                    <p
                                        *ngIf="
                                            section.description ||
                                            section.descriptionKey
                                        "
                                    >
                                        {{
                                            t(
                                                section.descriptionKey ??
                                                    section.description ??
                                                    ""
                                            )
                                        }}
                                    </p>

                                    <div *ngFor="let row of section.rows">
                                        <app-dynamic-form
                                            [formGroup]="disclosureForm"
                                            [fields]="row.fields"
                                            [formSubmitted]="submitted"
                                            [sectionValidators]="
                                                getSectionValidators(section)
                                            "
                                            [consentDescribedById]="
                                                'disclosure-consent-text'
                                            "
                                        >
                                        </app-dynamic-form>
                                    </div>
                                    <mat-error
                                        *ngFor="
                                            let validator of getSectionErrors(
                                                section
                                            )
                                        "
                                    >
                                        {{
                                            t(
                                                validator.messageKey ??
                                                    validator.message ??
                                                    validator.name
                                            ) ??
                                                validator.messageKey ??
                                                validator.message
                                        }}
                                    </mat-error>
                                </ng-container>
                            </div>
                        </ng-container>

                        <button
                            mat-stroked-button
                            class="submit"
                            type="submit"
                            [disabled]="submitting"
                        >
                            {{ t("application.submit-applications") }}
                        </button>
                        <div
                            class="terms-footer"
                            *ngIf="client?.disclosureTermsFooterHtml"
                            [innerHTML]="client?.disclosureTermsFooterHtml"
                        ></div>
                    </form>
                </mat-card>
            </div>
            <div
                fxFlex="334px"
                fxLayoutAlign="center center"
                class="right-area"
                fxFlex.xs="100"
                fxFlex.sm="100"
                fxHide.xs
                fxHide.sm
            >
                <mat-card appearance="outlined"> </mat-card>
            </div>
        </div>
    </div>
</ng-container>
